import script from "./ModalModificarLista.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalModificarLista.vue?vue&type=script&setup=true&lang=ts"

import "./ModalModificarLista.vue?vue&type=style&index=0&id=ab7b4442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab7b4442"]])

export default __exports__